import { render, staticRenderFns } from "./promotionalPlanData.vue?vue&type=template&id=07f3dbdb&scoped=true&class=full-height&"
import script from "./promotionalPlanData.vue?vue&type=script&lang=js&"
export * from "./promotionalPlanData.vue?vue&type=script&lang=js&"
import style0 from "./promotionalPlanData.vue?vue&type=style&index=0&id=07f3dbdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f3dbdb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/kinglinux/.baobaobot/teams/白/workspace_3GTAPP/projects/ita.GroupTravel.Website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f3dbdb')) {
      api.createRecord('07f3dbdb', component.options)
    } else {
      api.reload('07f3dbdb', component.options)
    }
    module.hot.accept("./promotionalPlanData.vue?vue&type=template&id=07f3dbdb&scoped=true&class=full-height&", function () {
      api.rerender('07f3dbdb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ita/components/promotionalPlanData.vue"
export default component.exports